import React from 'react'

const Flexbox_Coding_Pratice_2 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 2</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_2
